function ProductEarmoldsPage() {
    return <>ProductEarmoldsPage</>
}

export default ProductEarmoldsPage;